import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './msalInstance';
import { UserProvider } from './context/UserContext';
import { BrowserRouter,Routes, Route } from "react-router"; 
import AgendaGenerator from './pages/AgendaGenerator';
import OfficeMeetings from './pages/OfficeMeetings';
import ReportTools from './pages/ReportTools';
import StandardsPublish from './pages/StandardsPublish';
import PublicationReport from './pages/PublicationReport';
import AnnualReport from './pages/AnnualReport';
import QuarterlyReport from './pages/QuarterlyReport';
import ProposalReport from './pages/ProposalReport';
import VismaConnect from './pages/VismaConnect';

// https://reactrouter.com/start/declarative/routing

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
  <MsalProvider instance={msalInstance}>
    <UserProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/generate-agenda" element={<AgendaGenerator />} />
        <Route path="/report-tools" element={<ReportTools />}>
          <Route path='proposal-report' element={<ProposalReport />}/>
          <Route path='publication-report' element={<PublicationReport />}/>
          <Route path='annual-report' element={<AnnualReport />}/>
          <Route path='quarterly-report' element={<QuarterlyReport />}/>
          {/* <Route index path='standards-publish' element={<StandardsPublish />} /> */}
        </Route>
        <Route path="/office-meetings" element={<OfficeMeetings />} />
        <Route path="/visma" element={<VismaConnect />} />
        <Route path="/visma/callback" element={<VismaConnect />} />
      </Routes>
    </BrowserRouter>
    </UserProvider>
  </MsalProvider>
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
